import {CountryAutocompleteControlInterface} from '../../interfaces';

import {AutocompleteOptionInterface} from '../../components';
import {CountryAutocompleteItemInterface} from '../../widgets/country-autocomplete';

import {AutocompleteControl} from './autocomplete-control';

export class CountryAutocompleteControl extends AutocompleteControl {
    public countries: CountryAutocompleteItemInterface[];

    constructor(data: CountryAutocompleteControlInterface) {
        super(data);

        this.countries = data.countries;
    }

    setOptions(options: AutocompleteOptionInterface[]): void {
        this.options = options;
    }
}
